/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../app/dialogboxes/confirm.component';
import * as i2 from '@angular/common';
import * as i3 from '@ng-bootstrap/ng-bootstrap/modal/modal';
const styles_ConfirmComponent:any[] = ([] as any[]);
export const RenderType_ConfirmComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ConfirmComponent,data:{}});
function View_ConfirmComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'button',[['id',
      'confirmDlgConfirmButton'],['type','button']],[[8,'title',0],[8,'className',
      0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.execute()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['','']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.commandButtonTitleText;
        const currVal_1:any = i0.ɵinlineInterpolate(1,'btn btn-',_co.btnType,'');
        _ck(_v,0,0,currVal_0,currVal_1);
        const currVal_2:any = _co.commandButtonText;
        _ck(_v,1,0,currVal_2);
      });
}
export function View_ConfirmComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),10,'div',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          4,'button',[['aria-label','Close'],['class','close'],['id','confirmDlgCloseButton'],
              ['title','Close'],['type','button']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.ConfirmComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.cancel()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['aria-hidden','true']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['×'])),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'h4',[['class','modal-title']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['',''])),(_l()(),
          i0.ɵted((null as any),['\n'])),(_l()(),i0.ɵted((null as any),['\n'])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),7,'div',[['class','modal-body']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'div',[['class',
          'row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),1,'div',[['class','col-lg-12'],['style','white-space:pre']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵted((null as any),['\n'])),(_l()(),i0.ɵted((null as any),['\n'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),7,'div',[['class','modal-footer']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ConfirmComponent_1)),i0.ɵdid(16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'button',[['class','btn btn-secondary'],['id','confirmDlgCancelButton'],
              ['type','button']],[[8,'title',0]],[[(null as any),'click']],(_v,en,
              $event) => {
            var ad:boolean = true;
            var _co:i1.ConfirmComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.cancel()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' ',''])),
      (_l()(),i0.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i1.ConfirmComponent = _v.component;
    const currVal_3:any = _co.showCommandButton();
    _ck(_v,24,0,currVal_3);
  },(_ck,_v) => {
    var _co:i1.ConfirmComponent = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'modal-header alert-',_co.btnType,
        '');
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = _co.headerText;
    _ck(_v,9,0,currVal_1);
    const currVal_2:any = _co.confirmText;
    _ck(_v,17,0,currVal_2);
    const currVal_4:any = _co.cancelButtonTitleText;
    _ck(_v,26,0,currVal_4);
    const currVal_5:any = _co.cancelButtonText;
    _ck(_v,27,0,currVal_5);
  });
}
export function View_ConfirmComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'confirmDlg',([] as any[]),
      (null as any),(null as any),(null as any),View_ConfirmComponent_0,RenderType_ConfirmComponent)),
      i0.ɵdid(638976,(null as any),0,i1.ConfirmComponent,[i3.NgbModal],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ConfirmComponentNgFactory:i0.ComponentFactory<i1.ConfirmComponent> = i0.ɵccf('confirmDlg',
    i1.ConfirmComponent,View_ConfirmComponent_Host_0,{inputAction:'inputAction',confirmDlgAppliesTo:'confirmDlgAppliesTo',
        inputBtnType:'inputBtnType',dialogText:'dialogText',inputForId:'inputForId',
        inputForInstructionType:'inputForInstructionType'},{outputExecuteCommand:'outputExecuteCommand'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/$$_gendir/app/dialogboxes/confirm.component.ngfactory.ts